import type { RootState } from '@/store'

export const selectSelectedCounty = (state: RootState) => state.dashboard.selectedCounty

export const selectAppBarVisible = (state: RootState) => state.dashboard.appBarVisible

export const selectInitialSetupCompleted = (state: RootState) => state.dashboard.initialSetupCompleted
